import { EmployeeSalaryFare } from "bus/employeeSalary/types";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

export 	const onExporting = (
  refGridMain,
  refGridAdjustment,
  data: EmployeeSalaryFare | null,
  fullName: string,
  date: {
    dateBeginText: string;
    dateEndText: string;
  }
) => {
  const workbook = new Workbook();
  const main = workbook.addWorksheet('Основная информация');
  //const ratingSheet = workbook.addWorksheet('Корректировки');

  exportDataGrid({
    component: refGridMain.current?.instance,
    worksheet: main,
    autoFilterEnabled: true,
    topLeftCell: { row: 10, column: 1 },
  }).then(() => {
    // header
    const headerRow1 = main.getRow(1);
    const headerRow2 = main.getRow(2);
    const headerRow3 = main.getRow(3);
    const headerRow4 = main.getRow(4);
    const headerRow5 = main.getRow(5);
    const headerRow6 = main.getRow(6);
    const headerRow7 = main.getRow(7);
    const headerRow8 = main.getRow(8);
  
    main.mergeCells(1, 1, 1, 8);
    main.mergeCells(2, 1, 2, 8);
    main.mergeCells(3, 1, 3, 8);
    main.mergeCells(4, 1, 4, 8);
    main.mergeCells(5, 1, 5, 8);
    main.mergeCells(6, 1, 6, 8);
    main.mergeCells(7, 1, 7, 8);
    main.mergeCells(8, 1, 8, 8);
  
    headerRow1.getCell(1).value = 'Детализация заработной платы';
    headerRow1.getCell(1).font = { bold: true };
    headerRow1.getCell(1).alignment = { horizontal: 'center' };
  
    headerRow2.getCell(1).value = fullName;
    headerRow2.getCell(1).font = { bold: true };
    headerRow2.getCell(1).alignment = { horizontal: 'center' };
  
    headerRow3.getCell(1).value = `В период: ${date.dateBeginText} - ${date.dateEndText}`;
    headerRow3.getCell(1).font = { bold: true };
    headerRow3.getCell(1).alignment = { horizontal: 'center' };
  
    headerRow4.getCell(1).value = `Остаток на ${date.dateBeginText}: ${data?.balance}`;
    headerRow4.getCell(1).font = { bold: true };
    headerRow4.getCell(1).alignment = { horizontal: 'left' };
  
    headerRow5.getCell(1).value = `Оплачено: ${data?.pay}`;
    headerRow5.getCell(1).font = { bold: true };
    headerRow5.getCell(1).alignment = { horizontal: 'left' };
  
    headerRow6.getCell(1).value = `Оклад: ${data?.toPay}`;
    headerRow6.getCell(1).font = { bold: true };
    headerRow6.getCell(1).alignment = { horizontal: 'left' };

    headerRow7.getCell(1).value = `Корректировка: ${data?.adjustments}`;
    headerRow7.getCell(1).font = { bold: true };
    headerRow7.getCell(1).alignment = { horizontal: 'left' };

    headerRow8.getCell(1).value = `К оплате ${date.dateEndText}: ${data?.outBalance}`;
    headerRow8.getCell(1).font = { bold: true };
    headerRow8.getCell(1).alignment = { horizontal: 'left' };
  
  })
  .then(() => {
    workbook.xlsx.writeBuffer().then((buffer) => {
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
    });
  });
};